import { Camera } from "../types";

// Camera name sorter
const collator = new Intl.Collator(
    ['en', 'zh', 'jp', 'ko'],
    {
        numeric: true, sensitivity: 'base'
    }
)
export const sortByName = (item: Camera[]) =>
    item.sort((a, b) => collator.compare(a.name, b.name));
